var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShineCombinedMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 29,
    viewBox: "0 0 225 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14812_28125)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.69718,
    cy: 101.396,
    rx: 2.69718,
    ry: 101.396,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 11.0078 18.1307)",
    fill: "url(#paint0_linear_14812_28125)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_14812_28125)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.46042,
    cy: 83.3149,
    rx: 2.46042,
    ry: 83.3149,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 29.4707 15.9725)",
    fill: "url(#paint1_linear_14812_28125)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.7012,
    y: 12.2985,
    width: 102.7,
    height: 1.3,
    fill: "url(#paint2_linear_14812_28125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14812_28125",
    x: 0.103109,
    y: 1.80349,
    width: 224.593,
    height: 27.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.4504,
    result: "effect1_foregroundBlur_14812_28125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_14812_28125",
    x: 18.566,
    y: 0.124594,
    width: 188.432,
    height: 26.7227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.4504,
    result: "effect1_foregroundBlur_14812_28125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14812_28125",
    x1: 5.21855,
    y1: 202.62,
    x2: 5.04828,
    y2: 2.87638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14812_28125",
    x1: 4.76045,
    y1: 166.489,
    x2: 4.63443,
    y2: 2.36345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14812_28125",
    x1: 61.7012,
    y1: 12.9485,
    x2: 164.401,
    y2: 12.9485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522498,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShineCombinedMedium);
export default __webpack_public_path__ + "static/media/IconShineCombinedMedium.aacf2f1dee2106fd8a005dc10cac0f3c.svg";
export { ForwardRef as ReactComponent };